const {createBoolean, createObject, createString, traversePropertiesArray, traversePropertiesString, valueIf} = require('../../shared');

module.exports.beneficiaries = function (appData, formData, outData, formDataKey) {

  if (!outData.error && !createObject(appData, "beneficiaries", {primary: [], contingent: []})) {
    outData.error = "Cannot create beneficiaries info";
  }

  //Use Spouse/Primary (if married)
  const isMarried = appData.basic.relationshipStatus === "M";
  const benKey = (formDataKey === 'spouseBeneficiary' ? 'usePrimary' : 'useSpouse');
  const useSpouse = traversePropertiesString(formData, ['beneficiary', benKey]) === 1;
  const readFrom = valueIf(formDataKey === 'spouseBeneficiary', "primary", "spouse");
  if (isMarried && useSpouse) {
    let errorSection = 'beneficiary';
    let tempData = {};
    let name = [traversePropertiesString(formData, [readFrom, 'fname']), traversePropertiesString(formData, [readFrom, 'middleInitial']), traversePropertiesString(formData, [readFrom, 'lname'])].join(" ");
    if (!outData.error && !createString(tempData, "name", name, true)) {
      outData.error = "Cannot set name " + errorSection;
    }
    if (!outData.error && !createString(tempData, "ssn", traversePropertiesString(formData, [readFrom, 'ssn']), true)) {
      outData.error = "Cannot set ssn " + errorSection;
    }
    if (!outData.error && !createString(tempData, "dateOfBirth", traversePropertiesString(formData, [readFrom, 'bdate']), true)) {
      outData.error = "Cannot set dateOfBirth " + errorSection;
    }
    if (!outData.error && !createString(tempData, "relationship", "SPOUSE", true)) {
      outData.error = "Cannot set relationship " + errorSection;
    }
    if (!outData.error && !createString(tempData, "phone", traversePropertiesString(formData, [readFrom, 'phone']), true)) {
      outData.error = "Cannot set phone " + errorSection;
    }
    let street = valueIf(traversePropertiesString(formData, ['spouse', 'currentUseNew']) === "1", traversePropertiesString(formData, ['spouse', 'currentAddress']), traversePropertiesString(formData, ['primary', 'currentAddress']));
    if (!outData.error && !createString(tempData, "street", street, true)) {
      outData.error = "Cannot set street " + errorSection;
    }
    let zip = valueIf(traversePropertiesString(formData, ['spouse', 'currentUseNew']) === "1", traversePropertiesString(formData, ['spouse', 'currentZip']), traversePropertiesString(formData, ['primary', 'currentZip']));
    if (!outData.error && !createString(tempData, "zip", zip, true)) {
      outData.error = "Cannot set zip " + errorSection;
    }
    let share = valueIf(formDataKey === 'spouseBeneficiary', 'primaryShare', 'spouseShare');
    if (!outData.error && !createString(tempData, "sharePercent", traversePropertiesString(formData, ['beneficiary', share]), false)) {
      outData.error = "Cannot set spouseShare " + errorSection;
    }
    if (outData.error) {
      return true;
    } else {
      appData.beneficiaries.primary.push(tempData);
    }
  }


  //beneficiary
  if (!outData.error) { //Medication
    const beneficiaryData = traversePropertiesArray(formData, ['beneficiary', formDataKey]);
    beneficiaryData.some((beneficiaryFormData, index) => {
      const errorSection = formDataKey;
      let tempData = {};
      const samePhysician = valueIf(traversePropertiesString(beneficiaryFormData, ['samePhysician']) === "Y", true, false);

      if (!outData.error && !createString(tempData, "name", traversePropertiesString(beneficiaryFormData, ['fullName']), true)) {
        outData.error = "Cannot set name " + errorSection;
      }
      if (!outData.error && !createString(tempData, "ssn", traversePropertiesString(beneficiaryFormData, ['ssn']), false)) {
        outData.error = "Cannot set ssn " + errorSection;
      }
      if (!outData.error && !createString(tempData, "dateOfBirth", traversePropertiesString(beneficiaryFormData, ['bdate']), true)) {
        outData.error = "Cannot set dateOfBirth " + errorSection;
      }
      if (!outData.error && !createString(tempData, "relationship", traversePropertiesString(beneficiaryFormData, ['relationship']), true)) {
        outData.error = "Cannot set relationship " + errorSection;
      }
      if (!outData.error && !createString(tempData, "phone", traversePropertiesString(beneficiaryFormData, ['phone']), true)) {
        outData.error = "Cannot set phone " + errorSection;
      }

      const readAddress = valueIf(traversePropertiesString(beneficiaryFormData, ['useAddress']) === "", traversePropertiesString(beneficiaryFormData,
        ['beneficiaryAddress']),
        valueIf(traversePropertiesString(beneficiaryFormData, ['useAddress']) === "spouse", traversePropertiesString(formData, ['spouse', 'currentAddress']), traversePropertiesString(formData, ['primary', 'currentAddress'])));
      if (!outData.error && !createString(tempData, "street", readAddress, true)) {
        outData.error = "Cannot set street " + errorSection;
      }

      const readZip = valueIf(traversePropertiesString(beneficiaryFormData, ['useAddress']) === "",
        traversePropertiesString(beneficiaryFormData, ['beneficiaryZip']),
        valueIf(traversePropertiesString(beneficiaryFormData, ['useAddress']) === "spouse", traversePropertiesString(formData, ['spouse', 'currentZip']), traversePropertiesString(formData, ['primary', 'currentZip'])));
      let zip = valueIf(traversePropertiesString(formData, ['spouse', 'currentUseNew']) === "1", traversePropertiesString(formData, ['spouse', 'currentZip']), traversePropertiesString(formData, ['primary', 'currentZip']));
      if (!outData.error && !createString(tempData, "zip", readZip, true)) {
        outData.error = "Cannot set zip " + errorSection;
      }

      if (!outData.error && !createString(tempData, "sharePercent", traversePropertiesString(beneficiaryFormData, ['share']), false)) {
        outData.error = "Cannot set Share " + errorSection;
      }
      if (outData.error) {
        return true;
      } else {
        appData.beneficiaries.primary.push(tempData);
      }

    });
  }

  //contingency

  if (!outData.error) { //Medication
    formDataKey += "Contingency";
    const beneficiaryData = traversePropertiesArray(formData, ['beneficiary', formDataKey]);
    beneficiaryData.some((beneficiaryFormData, index) => {
      const errorSection = formDataKey;
      let tempData = {};
      const samePhysician = valueIf(traversePropertiesString(beneficiaryFormData, ['samePhysician']) === "Y", true, false);

      if (!outData.error && !createString(tempData, "name", traversePropertiesString(beneficiaryFormData, ['fullName']), true)) {
        outData.error = "Cannot set name " + errorSection;
      }
      if (!outData.error && !createString(tempData, "ssn", traversePropertiesString(beneficiaryFormData, ['ssn']), false)) {
        outData.error = "Cannot set ssn " + errorSection;
      }
      if (!outData.error && !createString(tempData, "dateOfBirth", traversePropertiesString(beneficiaryFormData, ['bdate']), true)) {
        outData.error = "Cannot set dateOfBirth " + errorSection;
      }
      if (!outData.error && !createString(tempData, "relationship", traversePropertiesString(beneficiaryFormData, ['relationship']), true)) {
        outData.error = "Cannot set relationship " + errorSection;
      }
      if (!outData.error && !createString(tempData, "phone", traversePropertiesString(beneficiaryFormData, ['phone']), true)) {
        outData.error = "Cannot set phone " + errorSection;
      }

      const readAddress = valueIf(traversePropertiesString(beneficiaryFormData, ['useAddress']) === "", traversePropertiesString(beneficiaryFormData,
        ['beneficiaryAddress']),
        valueIf(traversePropertiesString(beneficiaryFormData, ['useAddress']) === "spouse", traversePropertiesString(formData, ['spouse', 'currentAddress']), traversePropertiesString(formData, ['primary', 'currentAddress'])));
      if (!outData.error && !createString(tempData, "street", readAddress, true)) {
        outData.error = "Cannot set street " + errorSection;
      }

      const readZip = valueIf(traversePropertiesString(beneficiaryFormData, ['useAddress']) === "",
        traversePropertiesString(beneficiaryFormData, ['beneficiaryZip']),
        valueIf(traversePropertiesString(beneficiaryFormData, ['useAddress']) === "spouse", traversePropertiesString(formData, ['spouse', 'currentZip']), traversePropertiesString(formData, ['primary', 'currentZip'])));
      if (!outData.error && !createString(tempData, "zip", readZip, true)) {
        outData.error = "Cannot set zip " + errorSection;
      }

      if (!outData.error && !createString(tempData, "sharePercent", traversePropertiesString(beneficiaryFormData, ['share']), false)) {
        outData.error = "Cannot set Share " + errorSection;
      }
      if (outData.error) {
        return true;
      } else {
        appData.beneficiaries.contingent.push(tempData);
      }

    });
  }


  if (!outData.error && appData.beneficiaries.primary.length === 0) {
    outData.error = "Must specify at least 1 beneficiary";
  }


}


// WEBPACK FOOTER //
// ./src/containers/Applications/shared/appConverters/MBA/beneficiaries.js